import { ColumnDetails } from '../../../../../grid/types/common';
import { Column, ColumnKeys } from '../types';
import { html, nothing, TemplateResult } from 'lit';
import { SensorType } from '../../../types/sensor-type';

export function actionsRenderer(
  rowData: { item: any },
  columnDetails: ColumnDetails<Column, ColumnKeys>
): TemplateResult {
  return html` <span class="cell-label" style="display: flex;">
    <gz-icon-button
      buttonFill="quiet"
      buttonColor="secondary"
      buttonType="no_hover"
      icon="ds-icon-delete"
      size="24"
      fontSize="24"
      data-internal-id="${rowData.item._id}"
      @click="${this.onItemDelete.bind(this)}"
    ></gz-icon-button>
  </span>`;
}

export function confluenceCheckboxRenderer(rowData: { item: any }, columnDetails: ColumnDetails<Column, ColumnKeys>) {
  if (rowData.item.type === SensorType.ATLASSIAN_CONFLUENCE) {
    return html` <gz-form-field
      class="checkbox-field"
      readonly="${true}"
      ?disabled="${false}"
      style="position: relative;height: 18px;"
    >
      <gz-checkbox gz-form-input ?checked="${true}" style="position: absolute;bottom: 0;top: 0;height: 18px;">
      </gz-checkbox>
    </gz-form-field>`;
  }
  return nothing;
}

export function jiraCheckboxRenderer(rowData: { item: any }, columnDetails: ColumnDetails<Column, ColumnKeys>) {
  if (rowData.item.type === SensorType.ATLASSIAN_JIRA) {
    return html` <gz-form-field
      class="checkbox-field"
      readonly="${true}"
      ?disabled="${false}"
      style="position: relative;height: 18px;"
    >
      <gz-checkbox gz-form-input ?checked="${true}" style="position: absolute;bottom: 0;top: 0;height: 18px;">
      </gz-checkbox>
    </gz-form-field>`;
  }
  return nothing;
}
